import { render, staticRenderFns } from "./RemoveTask.vue?vue&type=template&id=2d05f627&"
import script from "./RemoveTask.vue?vue&type=script&lang=js&"
export * from "./RemoveTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports